"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Returns an array of html elements matching the cssSelector. If parentElement is set, only children of parentElement are returned.
 * @param {String} cssSelector
 * @param {HTMLElement} parentElement
 * @returns {HTMLElement[]}
 */
var getAll = function getAll(selector, parent) {
  var target = parent || document;
  var elements = target.querySelectorAll(selector);
  return Array.prototype.slice.call(elements);
};

var _default = getAll;
exports["default"] = _default;